import React from "react";
import moment from "moment";
import { Toast } from "service/toast";
import axios from "axios";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

export const history = require("history").createBrowserHistory({});

export const dateFormatter = (date, format = "DD/MM/YYYY") => {
  if (!date) return "";

  const finalDate = moment(date).format(format);
  return finalDate === "Invalid date" ? "" : finalDate;
};

export const permissionAccess = () => {
  const roleAccess = JSON.parse(sessionStorage.getItem("userDetails"));
  return roleAccess?.role;
};

export const regionAccess = () => {
  const roleAccess = JSON.parse(sessionStorage.getItem("userDetails") || "{}");
  const regionList = roleAccess?.project_details || [];

  const allowedRegionIds = regionList.map((item) => item.region_id);

  return (regionId) => allowedRegionIds.includes(Number(regionId));
};

// split filename from url
export const splitFileName = (urlData) => {
  if (urlData) {
    const filePath = urlData;
    const fileName = filePath.split("/").pop();
    return fileName;
  } else {
    return "";
  }
};

//  split image name from url
export const splitImageName = (url) => {
  if (url) {
    // Extract filename and extension using regex
    const matches = url.match(/\/([^/]+\.(?:jpg|png|jpeg|heic))/);

    // If a match is found, get the first capturing group
    const filenameWithExtension = matches ? matches[1] : "";

    return filenameWithExtension;
  }
};

// download csv
export const downloadCSV = (csvData, fileName) => {
  // Create a Blob from the CSV string
  const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });

  // Use FileSaver to save the Blob as a file
  saveAs(blob, fileName);
};

// download xlsx
export const downloadXlsx = (buffer, fileName) => {
  const uint8Array = new Uint8Array(buffer);
  // Parse the array buffer to a workbook
  const workbook = XLSX.read(uint8Array, { type: "array" });
  // Create a Blob from the workbook
  const workbookOut = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([workbookOut], { type: "application/octet-stream" });

  // Use FileSaver to save the Blob as a file
  saveAs(blob, fileName);
};

// Function to generate the filename
export const generateFilename = (fileExtension, fileName = "report") => {
  const now = new Date();
  const padToTwoDigits = (num) => num.toString().padStart(2, "0");

  const date = padToTwoDigits(now.getDate());
  const month = padToTwoDigits(now.getMonth() + 1); // Months are zero-indexed
  const year = now.getFullYear();
  const hours = padToTwoDigits(now.getHours());
  const minutes = padToTwoDigits(now.getMinutes());

  return `${date}-${month}-${year}_${hours}-${minutes}-${fileName}.${fileExtension}`;
};

// sample file download
export const sampleFileDownload = (fileUrlName, fileName) => {
  // Construct the file URL using process.env.PUBLIC_URL
  const fileUrl = `${process.env.PUBLIC_URL}/${fileUrlName}`;
  console.log("attentence repot url", fileUrl);
  // Create an anchor element
  const link = document.createElement("a");
  link.href = fileUrl;
  link.download = fileName;

  // Append the anchor to the document body and trigger a click event
  document.body.appendChild(link);
  link.click();

  // Remove the anchor from the document body
  link.remove();
};

export const getFormErrorMessage = (errors, fieldArrayError, name) => {
  if (!name || !errors) return null;

  if (!fieldArrayError && name) {
    return errors[name];
  }

  return !!errors?.[fieldArrayError.arrayName]?.[fieldArrayError.index]?.[
    fieldArrayError.fieldName
  ];
};

export const accessNestedFields = (obj, name) => {
  const keys = name.split(".");
  switch (keys.length) {
    case 1:
      return obj?.[keys?.[0]];
    case 2:
      return obj?.[keys?.[0]]?.[keys?.[1]];
    case 3:
      return obj?.[keys?.[0]]?.[keys?.[1]]?.[keys?.[2]];
    default:
      return;
  }
};

export const urlCombiner = (url) => {
  const protocol = ["h", "t", "t", "p", "s"].join("");
  return `${protocol}://${url}`;
};

export const defaultValidator = (val, defaultValue) => {
  return val != null ? val : defaultValue;
};

export const ToastError = (err) => {
  return Toast({ type: "error", message: err.Error || err.message || "Error" });
};

export const addQuery = (dataObject, apiObject) => {
  if (!dataObject) {
    return "";
  }

  const keys = [
    "page",
    "search",
    "size",
    "fileName",
    "dateModified",
    "url_id",
    "status",
    "startDate",
    "endDate",
    "unitId",
    "lineId",
    "mainList",
    "filterStatus",
    "unOrderedList",
    "type",
    "detailsId",
    "reqId",
    "limit",
    "color",
    "currentDate",
    "role",
    "region",
    "trade",
    "wings",
    "projects",
    "start_date",
    "end_date",
    "trade_id",
    "date",
    "project_id",
    "code",
    "sort_by",
    "order_by",
    "isExport",
    "slug",
    "trade_id",
    "from_date",
    "to_date",
    "work_location",
    "unit_measurement",
    "region_name",
    "wing_id",
    "work_area_id",
    "unit_id",
    "floor_id",
  ];

  keys.forEach((key) => {
    if (
      Object.prototype.hasOwnProperty.call(dataObject, key) &&
      typeof dataObject[key] !== "object"
    ) {
      if (apiObject.query.hasOwnProperty(key)) {
        apiObject.query[key] = dataObject[key];
      }
    } else {
      dataObject[key] &&
        Object.keys(dataObject[key]).forEach((keyName) => {
          if (apiObject.query.hasOwnProperty(keyName)) {
            apiObject.query[keyName] = dataObject[key][keyName];
          }
        });
    }
  });
};

export const generateQuery = (query) => {
  let url = "";
  if (query.hasOwnProperty("url_id")) {
    url = `/${query?.url_id}`;
  }

  return (
    url +
    Object.keys(query).reduce((accumulator, key, index) => {
      if (
        query[key] === "" ||
        query[key] == null ||
        key === "url_id" ||
        (query[key] !== null && query[key].toString().trim() === "")
      ) {
        return accumulator;
      } else {
        return accumulator + `${index !== 0 ? "&" : "?"}${key}=${query[key]}`;
      }
    }, "")
  );
};

export const generateAttendanceQuery = (query) => {
  let url = "";

  if (query.hasOwnProperty("url_id")) {
    url = `/${query?.url_id}`;
  }

  const alwaysIncludeKeys = ["from_date", "to_date"];

  return (
    url +
    Object.keys(query).reduce((accumulator, key) => {
      const value = query[key];

      if (
        value == null ||
        (value.toString().trim() === "" && !alwaysIncludeKeys.includes(key)) ||
        key === "url_id"
      ) {
        return accumulator;
      }

      return (
        accumulator + `${accumulator.includes("?") ? "&" : "?"}${key}=${value}`
      );
    }, "")
  );
};

export const getToken = () => {
  if (typeof window !== "undefined") {
    return sessionStorage.getItem("token") || localStorage.getItem("token");
  }
};

export const ternaryCondition = (val1, val2 = "", defaultValue = "") => {
  return val1 ? val2 : defaultValue;
};

//get s.no
export const getSNo = (index, page = 1) => {
  return parseInt((page - 1) * 10) + index + 1;
};

export const getIpAddress = async () => {
  const data = await axios({ method: "get", url: "https://api.ipify.org" });
  let ip = data?.data;
  localStorage.setItem("ip", ip);
};

export const getIp = () => {
  return defaultValidator(localStorage.getItem("ip"), "");
};

export const goBack = () => {
  history.goBack();
};

export const getRoleId = () => {
  let user = JSON.parse(localStorage.getItem("userDetails"));
  return user.role;
};

export const showHyphen = (data) =>
  data === null || data === undefined || data === "" ? "-" : data;

export const isSelected = (selected, id) => selected?.some((i) => i?.id === id);
// merge the employee code and id
export const mergeCodenId = (empCode, empId) => `${empCode}-${empId}`;

export const Roles = [
  {
    label: "Admin",
    value: 8,
  },
  {
    label: "Technician",
    value: 7,
  },
  {
    label: "Foreman / Supervisor",
    value: 6,
  },

  {
    label: "Project Head / Project Execution Head",
    value: 3,
  },
  {
    label: "Cost Auditor",
    value: 2,
  },
  {
    label: "Engineer / Project Manager",
    value: 4,
  },
  {
    label: "Super Admin",
    value: 1,
  },
  {
    label: "Manager",
    value: 9,
  },
];

export const Grades = [
  {
    label: "A",
    value: 1,
  },
  {
    label: "AA",
    value: 2,
  },
  {
    label: "AAA",
    value: 3,
  },
];

// department
export const Trades = [
  {
    label: "Tiles",
    value: 1,
  },
  {
    label: "POP",
    value: 2,
  },
  {
    label: "Granites",
    value: 3,
  },
  {
    label: "Aluminium",
    value: 4,
  },
  {
    label: "Aluminium",
    value: 5,
  },
];
export const Regions = [
  {
    label: "Kochi",
    value: "Kochi",
  },
  {
    label: "Kochi",
    value: "Kochi",
  },
  {
    label: "Chennai",
    value: "Chennai",
  },
  {
    label: "Mumbai",
    value: "Mumbai",
  },
  {
    label: "Hyderabad",
    value: "Hyderabad",
  },
  {
    label: "Pune",
    value: "Pune",
  },
];

export const getRoleLabelByValue = (value) => {
  const role = Roles.find((role) => role.value === value);
  return role ? role.label : null;
};

export const getGradeLabelByValue = (value) => {
  const grade = Grades.find((data) => data.value === value);
  return grade ? grade.label : null;
};

export const getTradeLabelByValue = (value) => {
  const trade = Trades.find((data) => data.value === value);
  return trade ? trade.label : null;
};
export const getRegionLabelByValue = (value) => {
  const region = Regions.find((data) => data.value === value);
  return region ? region.label : null;
};

// split the empcode and name
export const splitAndFormat = (input) => {
  if (input) {
    let parts = input?.split("-");
    let textPart = parts[0]?.charAt(0) + parts[0]?.slice(1).toUpperCase();
    let numberPart = parts[1];
    return [textPart, numberPart];
  } else {
    return ["", ""];
  }
};

export const projectNamesComma = (data, id) => {
  if (!data) return <span>-</span>;

  const firstTwoProjects = data.slice(0, 2);
  const remainingProjectsCount = data.length - 2;

  const firstTwoProjectsString = firstTwoProjects
    .map((d) => d.project_name)
    .join(", ");

  if (remainingProjectsCount > 0) {
    const handleClick = () => {
      history.push(`/users/view?userId=${id}/2`);
    };

    return (
      <button
        type="button"
        className="border-0 bg-transparent p-0"
        onClick={handleClick}
      >
        {firstTwoProjectsString}
        <span className="remaining__icon">+ {remainingProjectsCount}</span>
      </button>
    );
  } else {
    return <span>{firstTwoProjectsString}</span>;
  }
};

export const subActivityNamesComma = (data, id, subData) => {
  if (!Array.isArray(data)) return <span>-</span>;

  const filteredData = data.filter(
    (item) => item?.[subData] !== undefined && item?.[subData] !== null,
  );

  const firstProject = filteredData[0]; // Get the first project
  const remainingProjectsCount = filteredData.length - 1; // Count remaining projects

  const firstProjectString = firstProject ? firstProject[subData] : "";

  const regionCountButtonStyle = {
  border: 0,
  background: "transparent",
  padding: 0,
  margin: 0,
  font: "inherit",
  color: "inherit",
  lineHeight: "inherit",
  textAlign: "left",
  cursor: "pointer",
  boxShadow: "none",
  outline: "none",
};

const remainingIconStyle = {
  color: "blue",
  marginLeft: 2,
  font: "inherit",
};

  if (remainingProjectsCount > 0) {
    const handleClick = () => {
      history.push(`/activities/view/${id}/1`);
    };

    return (
      <button
        type="button"
        className="border-0 bg-transparent p-0"
        onClick={handleClick}
          style={regionCountButtonStyle}
      >
        {firstProjectString}
         <span style={remainingIconStyle}>+{remainingProjectsCount}</span>
      </button>
    );
  } else {
    return <span>{firstProjectString}</span>;
  }
};

export const formatRegionNames = (data, id) => {
  if (!data || !Array.isArray(data)) return <span>-</span>;

  const allRegions = data
    ?.flatMap((item) => item?.region?.map((r) => r?.region_name))
    .filter(Boolean);

  const firstRegion = allRegions[0];
  const remainingRegionsCount = allRegions.length - 1;
  const regionCountButtonStyle = {
    border: 0,
    background: "transparent",
    padding: 0,
    margin: 0,
    font: "inherit",
    color: "inherit",
    lineHeight: "inherit",
    textAlign: "left",
    cursor: "pointer",
    boxShadow: "none",
    outline: "none",
  };

  const remainingIconStyle = {
    color: "blue",
    marginLeft: 2,
    font: "inherit",
  };
  if (remainingRegionsCount > 0) {
    const handleClick = () => {
      history.push(`/activities/view/${id}/1`);
    };

    return (
      <button
        type="button"
        className="border-0 bg-transparent p-0"
        onClick={handleClick}
        style={regionCountButtonStyle}
      >
        {firstRegion}
        <span style={remainingIconStyle}>+{remainingRegionsCount}</span>
      </button>
    );
  } else {
    return <span>{firstRegion}</span>;
  }
};

export const gradeNamesComma = (data, id, gradeKey) => {
  if (!data || !Array.isArray(data) || !gradeKey) return <span>-</span>;

  const allGradeValues = data.flatMap((item) =>
    item?.region
      ?.map((region) => region?.[gradeKey])
      .filter((value) => value !== undefined && value !== null),
  );

  const uniqueValues = [...new Set(allGradeValues)];

  const firstTwo = uniqueValues.slice(0, 1);
  const remainingCount = uniqueValues.length - 2;

  const firstTwoString = firstTwo.join(", ");

  if (remainingCount > 0) {
    const handleClick = () => {
      history.push(`/activities/view/${id}`);
    };

    return (
      <button
        type="button"
        className="border-0 bg-transparent p-0"
        onClick={handleClick}
      >
        {firstTwoString}
        <span className="remaining__icon">+{remainingCount}</span>
      </button>
    );
  } else {
    return <span>{firstTwoString}</span>;
  }
};

export const allProjectNamesComma = (data) => {
  return data
    ?.map((d, index, array) => {
      if (index === array.length - 1) {
        return d?.project_name;
      } else {
        return `${d?.project_name}, `;
      }
    })
    .join("");
};

export const formatWingNames = (wings, id) => {
  if (!Array.isArray(wings) || wings.length === 0) return <span>-</span>;

  const firstTwo = wings.slice(0, 2);
  const remainingCount = wings.length - 2;

  const firstTwoString = firstTwo
    .map((w) => w?.wings_name)
    .filter(Boolean)
    .join(", ");

  const handleClick = () => {
    history.push(`/projects/view/${id}`);
  };

  if (remainingCount > 0) {
    return (
      <button
        type="button"
        className="border-0 bg-transparent p-0"
        onClick={handleClick}
      >
        {firstTwoString}
        <span className="remaining__icon"> +{remainingCount}</span>
      </button>
    );
  }

  return <span>{firstTwoString}</span>;
};

export const formatEntityNames = (
  entities,
  id,
  nameKey = "name",
  route = "/projects/view/",
) => {
  if (!Array.isArray(entities) || entities.length === 0) return <span>-</span>;

  const firstTwo = entities.slice(0, 2);
  const remainingCount = entities.length - 2;

  const firstTwoString = firstTwo
    .map((item) => item?.[nameKey])
    .filter(Boolean)
    .join(", ");

  const handleClick = () => {
    history.push(`${route}${id}`);
  };

  if (remainingCount > 0) {
    return (
      <button
        type="button"
        className="border-0 bg-transparent p-0"
        onClick={handleClick}
      >
        {firstTwoString}
        <span className="remaining__icon"> +{remainingCount}</span>
      </button>
    );
  }

  return <span>{firstTwoString}</span>;
};

export const NO_DATA = "No data found!";

export const isEmpty = (obj) => Object.keys(obj).length;

export const scrollToTop = () => window.scrollTo(0, 0);

export const generateOptions = (total, step = 10, maxOptions = 10) => {
  const options = [step];
  if (total > step) {
    for (let i = 2; i <= Math.min(Math.ceil(total / step), maxOptions); i++) {
      options.push(i * step);
    }
  }
  return options;
};
